import RunAsSoonAs from './RunAsSoonAs';
import GlobalVariables from '../GlobalVariables';
import Cookies from './Cookies';
import getCookieValue from './getCookieValue';

const logWidgetShown = function (companyKey) {
    if (getCookieValue('livechat_visitLogged') != 'true') {
        RunAsSoonAs(
            () => {
                const xhr = new XMLHttpRequest();
                xhr.open(
                    'GET',
                    `${GlobalVariables.ApexChatBaseUrl
                    }api/invitations/ping?logType=shown&visitorId=${getCookieValue(
                        'livechat_visitor_id'
                    )}&company=${companyKey}`
                );
                xhr.send();
                Cookies.setShortMinutes('livechat_visitLogged', true, 365);
            },
            () => getCookieValue('livechat_visitor_id') !== '0'
        );
    }
};
export default logWidgetShown;
